import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useSessionStorage } from '@thd-olt-global/thd-storage-utils';
import { ACCOUNT_BENEFITS_STORAGE_KEY } from '../util/constants';

/**
  * Hook to determine if the Projects feature is enabled for the user.
  * The query for this data is made by header-footer-static and we're depending on it here.
 */
export const useIsProjectsEnabled = () => {
  const { svocID } = useThdCustomer();
  const [benefitTagsStorage, _] = useSessionStorage(
    `${ACCOUNT_BENEFITS_STORAGE_KEY}${svocID}`,
    undefined,
    {
      stringifyInStorage: true,
    }
  );

  return {
    hasProjectBenefit: benefitTagsStorage?.projectBenefits || false,
  };
};
